module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": require("../assets/newsbanner.jpg"),
      "alt": "newsbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_1
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(0)
      }
    }
  }, [_vm._v("企业动态")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_2
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_vm._v("代理品牌动态")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_3
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_vm._v("行业资讯")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("新闻中心")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "nycon"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "news"
  }, [_c('ul', _vm._l((_vm.news_list), function(list, index) {
    return _c('li', [_c('div', {
      staticClass: "pic pull-left"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toNewsDetails(list)
        }
      }
    }, [_c('img', {
      staticClass: "vcenter",
      attrs: {
        "src": list.image,
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ntxt pull-left"
    }, [_c('a', {
      staticClass: "underline",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toNewsDetails(list)
        }
      }
    }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(list.desc))])]), _vm._v(" "), _c('div', {
      staticClass: "date pull-right"
    }, [_c('span', [_vm._v(_vm._s(list.updateTime))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toNewsDetails(list)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area paddingbottom30"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.total != 0) ? _c('Pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-no": _vm.pageNo,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "continues": 5
    },
    on: {
      "getPageNo": _vm.getPageNo
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1b0f954"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/News.vue
// module id = 311
// module chunks = 2